import Modal from 'react-modal';
import { IconCircleClose } from 'components/Icons';

type Props = {
  title: string;
  isOpen: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
};

function JournalEntriesConfirmationModal({ isOpen, title, handleClose, handleConfirm }: Props) {
  return (
    <Modal ariaHideApp={false} className="modal-accruals-confirmation" isOpen={isOpen}>
      <div className="modal-header">
        <div className="modal-title">
          <h6>{title}</h6>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <IconCircleClose onClick={handleClose} />
        </div>
      </div>
      <div className="modal-body">
        <p>Are you sure that you want to cancel this journal entries changes?, you will lose all the changes made.</p>
        <div className="modal-body-actions">
          <button onClick={handleClose} className="cancel-btn">
            CANCEL
          </button>
          <button onClick={handleConfirm}>CONFIRM</button>
        </div>
      </div>
    </Modal>
  );
}

export default JournalEntriesConfirmationModal;
